// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__9KJIE","info":"Note_info__2JHuo","note":"Note_note__2FlQ7","actions":"Note_actions__3yeBp"};